import React, { useState, useEffect } from "react";
import { useSelector, useDispatch} from "react-redux";
import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
} from "reactstrap";
import {
	Image
} from "antd";
import {
    LogoutOutlined,
    UserOutlined
} from "@ant-design/icons";

import { getProfile } from "../../store/actions";
//import images
import avatar from "../../assets/images/avartar.png";
import { getUserIdStorage } from "../../helpers/common";
import { useUserDetails } from "../../context/UserDetailContext";

const ProfileDropdown = () => {
    const dispatch = useDispatch();
    const [src, setSrc] = useState(avatar);
    const { userDetails, setUserDetails } = useUserDetails();

    useEffect(() => {
        dispatch(getProfile(getUserIdStorage()));
    }, [])

    const { user, url_img } = useSelector((state) => ({
        user: state.Profile.user,
        url_img: state.Profile.url_img
    }));
    
    const [infoUser, setInfoUser] = useState({
        fullName: "",
        role: "",
        username: ""
    });
    
    useEffect(() => {
        if (user && user.avatar){
            setSrc(`${process.env.REACT_APP_API_URL}/uploads/images/${user.avatar}`);
        }
    }, [user])

    useEffect(() => {
        if (url_img) setSrc(url_img);
    }, [url_img])
    

    useEffect(() => {
        if (userDetails) {
            setInfoUser({
                fullName: userDetails.fullName,
                role: userDetails.role ? userDetails.role.roleName : '',
                username: userDetails.username
            });
        }
    }, [userDetails]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };
    const clearCache = () => {
        sessionStorage.removeItem("pathRoleUser");
    }
    return (
        <>
            <Dropdown
                isOpen={isProfileDropdown}
                toggle={toggleProfileDropdown}
                className="ms-sm-3 header-item topbar-user"
            >
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <Image
                            className="rounded-circle header-profile-user"
                            height={40}
                            width={40}
                            preview={false}
                            src={src}
                            fallback={avatar}
                        />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                {infoUser.username}
                            </span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                                {infoUser.roleName}
                            </span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Chào mừng {infoUser.fullName ? infoUser.fullName : infoUser.username}!</h6>
                    <DropdownItem href="/profile">
                        <UserOutlined className="text-muted fs-16 align-middle me-1"/>
                        <span className="align-middle">Tài khoản</span>
                    </DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem href="/logout" onClick={clearCache}>
                        <LogoutOutlined className="text-muted fs-16 align-middle me-1" />{" "}
                        <span className="align-middle" data-key="t-logout">
                            Đăng xuất
                        </span>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </>
    );
};

export default ProfileDropdown;
